<script>
	import { scrollTo } from '$lib/utils/navutils.js';
</script>

<button class="btn btn-primary mt-2" on:click={() => scrollTo('request-demo')}>Sign up</button>
